<template>
  <div v-rect-loading="loading" class="table-container">
    <el-table
      class="rate-management-table"
      ref="rateTableRef"
      row-key="legacy_record_id"
      tooltip-effect="light"
      max-height="688"
      :data="data"
      :header-row-style="{ height: '60px' }"
      :header-cell-style="{ background: '#f9f9f9' }"
    >
      <!-- 邀请评估时间 -->
      <el-table-column prop="inviteDate" :min-width="tableColumnWidthMap.inviteDate" :label="$t(`${i18nPrefix}.label.rateDate`)">
        <template #default="{ row }">
          <div class="date">{{ row.inviteDate }}</div>
          <div class="time">{{ row.inviteTime }}</div>
        </template>
      </el-table-column>
      <!-- 公司 -->
      <el-table-column v-if="showCompany" show-overflow-tooltip prop="companyName" :min-width="tableColumnWidthMap.companyName" :label="$t(`${i18nPrefix}.label.entity`)"></el-table-column>
      <!-- 职位 -->
      <el-table-column v-if="showJob" show-overflow-tooltip prop="jobName" :min-width="tableColumnWidthMap.jobName" :label="$t(`${i18nPrefix}.label.job`)"></el-table-column>
      <!-- 招聘人员 -->
      <el-table-column prop="recruiter" show-overflow-tooltip :min-width="tableColumnWidthMap.recruiter" :label="$t(`${i18nPrefix}.label.organizer`)">
      </el-table-column>
      <!-- 招聘经理 -->
      <el-table-column prop="hiringManagerNames" show-overflow-tooltip :min-width="tableColumnWidthMap.hiringManagerNames" :label="$t(`${i18nPrefix}.label.hiringManagerNames`)">
      </el-table-column>
      <!-- 求职者 -->
      <el-table-column prop="candidateNames" show-overflow-tooltip :min-width="tableColumnWidthMap.candidateNames" :label="$t(`${i18nPrefix}.label.candidateNames`)">
        <template #default="{ row }">
          <div class="candidate-names single-candidate" @click="handleCandidateNameClick(row)">{{ row.candidateNames }}</div>
        </template>
      </el-table-column>
      <!-- 状态 -->
      <el-table-column prop="status" class-name="status" show-overflow-tooltip :min-width="tableColumnWidthMap.status" :label="$t(`${i18nPrefix}.label.status`)">
        <template #default="{ row }">
          <template v-if="row.status === RATE_STATUS.NOT_RECOMMENDED || row.status === RATE_STATUS.RECOMMENDED">
            <div class="finished">{{ $t(`${i18nPrefix}.label.FINISHED`) }}</div>
          </template>
          <template v-else>
            <div class="pending">{{ $t(`${i18nPrefix}.label.PENDING`) }}</div>
          </template>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column v-if="hasInviteHMRatePermission" show-overflow-tooltip prop="action" class-name="single-action" :min-width="tableColumnWidthMap.action" :label="$t(`${i18nPrefix}.label.action`)">
        <template #default="{ row }">
          <template v-if="row.status === RATE_STATUS.NOT_RECOMMENDED || row.status === RATE_STATUS.RECOMMENDED">-</template>
          <el-dropdown v-else :ref="`actionDropdown_${row.uuid}`" class="action-dropdown" trigger="click" :disabled="row.noAction" @command="handleAction($event, row)">
            <el-button v-if="row.noAction" v-auto-tooltip.always="row.disabledTooltip" disabled class="dropdown-btn is-disabled">
              <span>{{ $t('common.label.operate') }}</span>
              <i class="dropdown-btn-icon el-icon-more"></i>
            </el-button>
            <el-button v-else class="dropdown-btn">
              <span>{{ $t('common.label.operate') }}</span>
              <i class="dropdown-btn-icon el-icon-more"></i>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu class="no-arrow-dropdown-menu">
                <template v-if="row.status !== RATE_STATUS.NOT_RECOMMENDED && row.status !== RATE_STATUS.RECOMMENDED">
                  <el-dropdown-item command="sendInviteRating">{{ $t(`${i18nPrefix}.btn.resendHmRating`) }}</el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import _ from 'lodash'
import { RATE_STATUS } from '@/constant/interview'

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    showCompany: {
      type: Boolean,
      default: false
    },
    showJob: {
      type: Boolean,
      default: false
    },
    isScrollable: {
      type: Boolean,
      default: false
    },
    tableColumnWidthMap: {
      type: Object,
      required: true
    },
    singleActionBtn: {
      type: Boolean,
      default: false
    },
    isProfile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      RATE_STATUS,
      emitSearch: null,
      search: {
        keywords: null,
        status: null
      },
      emitScrollBottom: null,
      atBottom: false
    }
  },
  computed: {
    hasInviteHMRatePermission () {
      return this.hasAnyPermission(['PERM_INVITE_HM_REVIEW', 'PREMIUM_INVITE_HM_REVIEW'])
    }
  },
  created () {
    this.emitSearch = _.debounce(() => {
      this.$emit('search', this.search)
    }, 500)
    this.emitScrollBottom = _.debounce(() => {
      this.$emit('scrollBottom')
    }, 500)
  },
  mounted () {
    const el = this.$el.querySelector('.el-table__body-wrapper')
    el.addEventListener('scroll', () => {
      const distance = el.scrollHeight - el.scrollTop - el.clientHeight - 10
      if (distance <= 50) {
        if (!this.atBottom) {
          this.emitScrollBottom()
        }
        this.atBottom = true
      } else {
        this.atBottom = false
      }
    })
  },
  methods: {
    handleSendInviteRating (record) {
      this.$emit('sendRating', record)
    },
    handleAction (command, row) {
      if (row.noAction) {
        return
      }
      if (command === 'sendInviteRating') {
        this.handleSendInviteRating(row)
      }
    },
    handleCandidateNameClick (row) {
      if (!row.candidate.id) {
        return
      }
      this.$emit('openCandidateDetail', row)
    }
  },
  watch: {
    data: {
      handler () {
        const tableRef = this.$refs.rateTableRef
        tableRef.layout.updateElsHeight()
      }
    },
    search: {
      deep: true,
      handler () {
        this.emitSearch()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-container {
  position: relative;

  .rate-management-table {
    border-bottom: 0;

    .dropdown-link {
      cursor: pointer;

      .el-icon-arrow-down {
        margin-left: 5px;
      }
    }

    .single-candidate {
      cursor: pointer;
      color: #0096cc;
    }

    .action-btn, .more, .el-icon-arrow-down {
      color: #0096cc;
    }

    .candidate-names {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .status {
      .cell {
        > * {
          word-break: break-word;
        }
      }
    }

    .action {
      .cell {
        > * {
          word-break: break-word;
        }
      }
    }

    .single-action {
      .cell {
        > * {
          word-break: break-word;
        }
      }

      .action-dropdown {
        .dropdown-btn {
          padding: 6px 14px;
          font-size: 14px;
          line-height: 18px;
          border-color: #0096cc;
          color: #0096cc;
          font-weight: 500;
          border-radius: 2px;

          .dropdown-btn-icon {
            margin-left: 5px;
            transform: rotate(90deg);
          }

          &.is-disabled {
            color: #c0c4cc;
            border-color: #ebeef5;
          }
        }
      }
    }

    .pending {
      color: #f4a958;
    }

    .scheduled {
      color: #51abff;
    }

    .finished {
      color: #51bf82;
    }

    .canceled {
      color: #909399;
    }

    .hm-name {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    ::v-deep {
      .el-table__header {
        tr {
          th {
            &:first-child {
              padding-left: 40px;
            }

            .cell {
              word-break: break-word;
            }
          }
        }
      }

      .el-table__body {
        .el-table__row {
          .el-table__cell:first-child {
            padding-left: 40px;
          }
        }
      }
    }
  }

  .loading {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
